<template>
  <div class="service-page4">
    <div v-if="!showResultPage">
      <p class="donation-hint">{{ offeringInfoContent }}</p>
      <inputField
        class="donation-input"
        id="donationAmount"
        label="金額"
        placeholder="請輸入"
        maxLength="5"
        inputType="int"
        :value="donationAmount"
        :errorText="errorText.donationAmount"
        @onInput="onInput($event)"
      />
      <div class="button-section">
        <div
          class="temple-button-text"
          @click="handleConfirm"
        >
          確認
        </div>
      </div>
    </div>
    <div v-else>
      <serviceLightStep5 :orderStatus="orderStatus" :showQueryButton="false" />
    </div>
  </div>
</template>

<script>
import inputField from 'Components/inputField/inputField.vue';
import store from 'Store/store';
import serviceLightStep5 from 'Pages/ServiceModule/ServiceLight/ServiceLightStep5.vue';

export default {
  name: 'ServicePage4',
  components: {
    inputField,
    serviceLightStep5,
  },
  mounted() {
    this.$emit('getOrderStatus');
  },
  computed: {
    offeringInfoContent() {
      if (store.state.main.onlineStatus.offeringInfo && store.state.main.onlineStatus.offeringInfo.serviceInfo) {
        return store.state.main.onlineStatus.offeringInfo.serviceInfo.content
      }
      return '香油錢可隨緣贊助，不拘金額'
    },
    orderStatus() {
      return store.state.main.orderStatus;
    },
  },
  data() {
    return {
      donationAmount: '',
      errorText: {
        donationAmount: '',
      },
      showResultPage: false,
    };
  },
  methods: {
    onInput(inputValue) {
      this.donationAmount = inputValue.donationAmount;
      // Clear error when user starts typing
      this.errorText.donationAmount = '';
    },
    handleConfirm() {
      // Validate the input
      if (!this.donationAmount || this.donationAmount === '') {
        this.errorText.donationAmount = '必填';
        return;
      }
      
      const amount = parseInt(this.donationAmount);
      
      if (amount <= 0) {
        this.errorText.donationAmount = '金額必須大於 0 元';
        return;
      }
      
      if (amount > 10000) {
        this.errorText.donationAmount = '金額大於一萬元，請透過現場櫃檯樂捐！';
        return;
      }
      
      // Clear any previous errors
      this.errorText.donationAmount = '';

      if (amount > 1000) {
        store.dispatch('main/showConfirmModal', {
          title: '系統訊息',
          content: `樂捐金額${amount.toLocaleString()}，大於1,000元 請再次確認！`,
          confirmText: '確認捐款',
          cancelText: '取消',
          onConfirm: () => {
            this.submitDonation();
          },
        });
        return;
      }
      
      // Submit donation
      this.submitDonation();
    },
    submitDonation() {
      // Construct payload
      const payload = {
        Price: parseInt(this.donationAmount),
        PaymentType: 0, // Hardcoded
        ServiceId: store.state.main.onlineStatus.offeringInfo.serviceInfo.id,
        PolicyId: store.state.main.onlineStatus.policyInfo.id,
      };

      let strInfoRequest = JSON.stringify(payload);
      let offeringMoneyRequest = { param: strInfoRequest };

      store.dispatch('main/offeringMoney', offeringMoneyRequest);
      this.donationAmount = '';
    },
    showResult() {
      this.showResultPage = true;
    }
  }
};
</script>

<style scoped>
.service-page4 {
  padding: 20px 0;
}

.donation-hint {
  color: #666;
  font-size: 16px;
  margin-bottom: 30px;
  text-align: left;
}

.donation-input {
  width: 50%;
}

.currency {
  position: absolute;
  right: 15px;
  font-size: 16px;
  color: #666;
}

.button-section {
  margin-top: 50px;
  align-items: center;
  display: flex;
  justify-content: center;
}

@media (max-width: 767px) {
  .donation-input {
    width: 100%;
  }
}
</style>
